// slips.js — งานฝั่งสลิปที่ต้อง "รอปุ่มบันทึก" ของ dialog (multi-slip, MULTI_SLIP_DESIGN.md)
//
// กติกาที่เจ้าของเคาะ 2026-08-21: ทั้งการ "แนบ" และการ "ลบ" สลิป ต้องไม่มีผลจริงจนกว่าผู้ใช้
// จะกดปุ่มบันทึกของ dialog — กดผิดแล้วกดยกเลิกต้องกู้คืนได้เสมอ
//   • แนบ → SlipListPanel เก็บไฟล์ไว้ในคิว (pending-files) พ่อแม่ append เข้า FormData ตอน save
//   • ลบ  → SlipListPanel แค่ "ทำเครื่องหมาย" (pending-deletes) พ่อแม่เรียกฟังก์ชันนี้ตอน save
import axios from 'axios';

// ดึงรายการสลิปของรายการหนึ่ง "ล่วงหน้า" ก่อนเปิด dialog (เจ้าของสั่ง 2026-08-21: เตรียมข้อมูล
// ให้ครบก่อนค่อยแสดง dialog ไม่ใช่เปิดแล้วค่อยเติมทีละช่อง) — ส่งผลลัพธ์ให้ SlipListPanel ทาง
// prop `preloaded` แล้วพาเนลจะไม่ยิงซ้ำตอน mount · คืน null เมื่อดึงไม่ได้ = พาเนลดึงเองตามเดิม
export async function fetchSlipImages(baseURL, token, context, refer) {
  if (!context || refer === null || refer === undefined || refer === '') return null;
  try {
    const response = await axios.get(`${baseURL}/slipImages/${context}/${encodeURIComponent(refer)}`,
      { headers: { Authorization: 'Bearer ' + token } });
    return (response.data && response.data.success) ? response.data : null;
  } catch (error) {
    return null;
  }
}

// ลบสลิปที่ถูกทำเครื่องหมายไว้ — เรียกจากขั้นตอนบันทึกของ dialog เท่านั้น
//
// ⚠️ ต้องรัน **ก่อน** คำขอบันทึกหลักที่แนบไฟล์ใหม่เสมอ: backend นับเพดาน 3 ใบจากสถานะจริงใน
// ตาราง ถ้าอัพไฟล์ใหม่ก่อนลบใบเก่า การสลับใบ (ลบ 1 + เพิ่ม 1) จะถูกปฏิเสธว่าเกินเพดาน
//
// ไม่ throw — คืน { ok, failed } ให้ผู้เรียกตัดสินใจเองว่าจะแจ้งผู้ใช้อย่างไร (การลบสลิปพลาด
// ไม่ควรทำให้การบันทึกข้อมูลหลักล้มตาม)
export async function deleteQueuedSlips(baseURL, token, slipIds) {
  const ids = (slipIds || []).filter((id) => id !== null && id !== undefined && id !== '');
  const failed = [];
  for (const slipid of ids) {
    try {
      const response = await axios.post(`${baseURL}/deleteSlipImage`, { slipid },
        { headers: { Authorization: 'Bearer ' + token } });
      if (!response.data || !response.data.success) failed.push(slipid);
    } catch (error) {
      failed.push(slipid);
    }
  }
  return { ok: ids.length - failed.length, failed };
}

export default { fetchSlipImages, deleteQueuedSlips };
